import {
  AArrowDown,
  ChevronRight,
  Check,
  Plus,
  Info,
  ClipboardCopy,
  LogIn,
  ArrowLeft,
  ArrowUpRight,
  ArrowRight,
  CircleAlert,
  Lock,
} from "lucide-react";

export const icons = {
  "a-arrow-down": AArrowDown,
  plus: Plus,
  "chevron-right": ChevronRight,
  check: Check,
  info: Info,
  "clipboard-copy": ClipboardCopy,
  "log-in": LogIn,
  "arrow-left": ArrowLeft,
  "arrow-up-right": ArrowUpRight,
  "arrow-right": ArrowRight,
  "circle-alert": CircleAlert,
  lock: Lock,
} as const;

export type IconName = keyof typeof icons;
